export default __webpack_public_path__ + "static/media/E04.25a0f5e1.mp3";